module.exports = __webpack_public_path__ + "media/paliwa/other@3x-d11d89bd.svg";